import React from 'react';
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  IconButton,
} from '@mui/material';
import { HelpRounded } from '@mui/icons-material';
import useTranslation from '../customHooks/translations';
import GradientLightbulb from './GradientLightbulb';
import SmartToyGradient from './SmartToyGradient';

const UploadPhotoTitlePopover = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'upload-popover' : undefined;

  const translation = useTranslation();
  const secondaryHeadingSx = {
    fontFamily: '"Outfit", "DM Sans", sans-serif',
    fontWeight: 700,
    fontSize: 'clamp(1.45rem, 1.1rem + 0.9vw, 1.9rem)',
    lineHeight: 1.16,
    letterSpacing: '-0.02em',
    color: '#0F172A',
  };
  const regularTextSx = {
    fontFamily: '"DM Sans", sans-serif',
    fontSize: '1rem',
    lineHeight: 1.5,
    color: '#64748B',
    fontWeight: 400,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
      }}
    >
      <Typography
        component="div"
        variant="h2"
        sx={{
          display: 'inline-flex',
          gap: '0.5rem',
          my: '0.4em',
          ...secondaryHeadingSx,
          alignItems: 'center',
        }}
      >
        {translation.showUsTheProof}
        <IconButton
          onClick={handlePopover}
          aria-label={translation?.logActionPage?.imageUploadInstructions}
        >
          <HelpRounded />
        </IconButton>
      </Typography>
      <Typography
        variant="body1"
        component="p"
        sx={{
          mt: '0.35rem',
          mb: '0.9rem',
          mx: 0,
          ...regularTextSx,
          maxWidth: '34rem',
        }}
      >
        {translation.imageValidationText}
      </Typography>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '1rem',
            gap: '0.95rem',
          }}
        >
          <SmartToyGradient />
          <Typography
            variant="h5"
            sx={{ color: '#0F172A', fontWeight: 800, fontSize: '1.25rem' }}
          >
            {translation.uploadPhoto}
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <GradientLightbulb /> {translation.topTips}
          </Typography>
          <List sx={{ padding: '0 2rem', listStyleType: 'disc' }}>
            <ListItem sx={{ display: 'list-item' }}>
              {translation.imageValidationDimensions}
            </ListItem>
            <ListItem sx={{ display: 'list-item', textAlign: 'wrap' }}>
              {translation.uploadImageInfo}
            </ListItem>
          </List>
        </Box>
      </Popover>
    </Box>
  );
};

export default UploadPhotoTitlePopover;
